import React from 'react';
import { Modal, Backdrop, Fade, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import PaymentsSchedulePaymentsStep1 from './PaymentsSchedulePaymentsStep1';
import PaymentsSchedulePaymentsStep2 from './PaymentsSchedulePaymentsStep2';
import PaymentsSchedulePaymentsStep3 from './PaymentsSchedulePaymentsStep3';
import PaymentsSchedulePaymentsSuccess from './PaymentsSchedulePaymentsSuccess';
import { StepperContainer } from './StepperFlow';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99,
  },
  paper: {
    width: '100%',
    height: '100vh',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
  },
}));

const PaymentsScheduleInvoicesStepper = props => {
  const { open, closeModal } = props;
  const classes = useStyles();

  const SCHEDULE_STEPS = [
    {
      label: 'Fecha de pago',
      component: <PaymentsSchedulePaymentsStep1 />,
    },
    {
      label: 'Facturas',
      component: <PaymentsSchedulePaymentsStep2 />,
    },
    {
      label: 'Resumen',
      component: <PaymentsSchedulePaymentsStep3 />,
      customButtons: true,
    },
  ];

  const SCHEDULE_STEPS_COMPLETED = {
    component: <PaymentsSchedulePaymentsSuccess />,
  };

  return (
    <Modal
      disableEnforceFocus
      disableAutoFocus
      closeAfterTransition
      disablePortal
      className={classes.modal}
      open={open}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade style={{ padding: 0 }} in={open}>
        <div className={classes.paper}>
          <StepperContainer
            title="Programación de facturas"
            closeModal={closeModal}
            steps={SCHEDULE_STEPS}
            stepCompleted={SCHEDULE_STEPS_COMPLETED}
          />
        </div>
      </Fade>
    </Modal>
  );
};

PaymentsScheduleInvoicesStepper.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default PaymentsScheduleInvoicesStepper;
